import { Modal, Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { resetProductsState } from "@services/redux/store";
import { resetStep } from "@services/redux/slices/stepSlice";

const CancelModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleConfirmCancel = () => {
    resetProductsState();
    resetStep();
    localStorage.removeItem("productTypeInfo");
    localStorage.removeItem("product");
    onClose();
    navigate("/new-product");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="xs"
      keyboard={false}
      backdrop="static"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="text-center p-5"
      >
        <h4 className="mb-3 fw-bold text-dark">
          {t("are_you_sure_you_want_to_cancel")}
        </h4>

        <p className="mb-4 text-muted">{t("all_data_will_be_gone")}</p>

        <div className="d-grid gap-3">
          <Button
            appearance="primary"
            block
            onClick={handleConfirmCancel}
            className="btn-lg fw-semibold py-3"
            style={{
              backgroundColor: "#8077EC",
              borderColor: "#8077EC",
              color: "#fff",
            }}
          >
            {t("yes_cancel")}
          </Button>

          <Button
            appearance="subtle"
            block
            onClick={onClose}
            className="btn-lg fw-semibold py-3"
          >
            {t("no_go_back")}
          </Button>
        </div>
      </motion.div>
    </Modal>
  );
};

export default CancelModal;
